import { motion } from "framer-motion";
import { I18n } from "@assets/strings";
import React from "react";
import styled, { useTheme } from "styled-components";
import computerImage from "@assets/images/auth/computer.png";
import pencilImage from "@assets/images/auth/pencil.png";
import tabletImage from "@assets/images/auth/tablet.png";
import { useModalTools } from "@ui/modals/modalContext";
import { mobile, scaledPx } from "@ui/styles/utils";
import { Z } from "@ui/styles/zIndex";
import { AuthModal } from "@ui/components/auth/authModal";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { PrimaryBold } from "@ui/components/containers/primary";
import { stack } from "./layout";
import { Rectangle } from "@ui/components/shapes/rectangle";

interface AppAuthIncentiveProps {
	message?: string;
}
export const AppAuthIncentive: React.FC<AppAuthIncentiveProps> = ({ message }) => {
	const theme = useTheme();
	const { createModal } = useModalTools();

	return (
		<Container
			initial={{ y: "100%" }}
			animate={{ y: 0 }}
			transition={{ type: "spring", delay: 4, stiffness: 220, damping: 20 }}
		>
			<DesktopRectangle
				color={theme.colors.orange}
				radius={33}
				width={400}
				height={1200}
				angle={-15}
				top={-100}
				left={-100}
			/>
			<DesktopRectangle
				color={theme.colors.secondary}
				radius={33}
				width={400}
				height={1200}
				angle={-15}
				top={-100}
				right={-300}
			/>

			<Tablet src={tabletImage} />
			<Pencil src={pencilImage} />
			<Computer src={computerImage} />
			{message ? <PrimaryBold>{message}</PrimaryBold> : null}
			<PrimaryButton onClick={() => createModal((close) => <AuthModal close={close} />)}>
				{I18n.t("login.button.submit")}
			</PrimaryButton>
		</Container>
	);
};

const Container = styled(motion.div)`
	position: fixed;
	bottom: -100px;
	left: 0;
	right: 0;
	z-index: ${Z.toolbar};
	padding: 56px ${scaledPx(340)};
	padding-bottom: 156px;
	${stack(40, "flex-start", "center")};
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.white};
	box-shadow: 0 2px 34px 0 rgba(0, 0, 0, 0.2);

	@media ${mobile} {
		padding: 20px;
		padding-bottom: 120px;
		${stack(20, "flex-start", "center")};
		> img {
			display: none;
		}
	}
`;

const DesktopRectangle = styled(Rectangle)`
	@media ${mobile} {
		display: none;
	}
`;

const Tablet = styled.img`
	position: absolute;
	right: ${scaledPx(1440 - 310)};
	top: 75px;
	width: 130px;
`;
const Pencil = styled.img`
	position: absolute;
	right: ${scaledPx(1440 - 340)};
	top: 96px;
	width: 14px;
`;

const Computer = styled.img`
	position: absolute;
	left: ${scaledPx(1440 - 340)};
	top: 66px;
	width: 280px;
`;
